export default __webpack_public_path__ + "static/media/arhunt.aaf3d24c.png";